var coloursMixin = {
	data: function () {
		return {
			colours: [],
			showColoursModal: false,
			product: {
				colour: '',
			},
			selected: {
				product: {
					colour: '',
					hexadecimalCode: '',
				},
			},
		};
	},
	methods: {
		addColours: function (colourMatrixItems) {
			const vm = this;

			var items = [];
			colourMatrixItems.forEach(function (element) {
				items.push(element.colours);
			});

			vm.colours = items;
		},
		closeColoursModal: function () {
			const vm = this;

			vm.showColoursModal = false;
			document.body.classList.remove('modal-open');
		},
		openColoursModal: function () {
			const vm = this;
			vm.showColoursModal = true;
			document.body.classList.add('modal-open');

			if (document.querySelector('#typeface-preview') != null) {
				window.observerImages.observe();
			}
		},
		resetColours: function () {
			const vm = this;
			vm.hasColours = false;
			vm.selected.product.colour = {};
			vm.$refs['selectColor'].required = false;
			vm.colours = [];
			vm.product.colour = {};
			vm.thicknesses = [];
		},
		selectColour: function (colour) {
			const vm = this;
			const colourMatrixItem = vm.colourMatrixItems.find(
				(items) => items.colours.definitionFieldId === colour.definitionFieldId
			);

			vm.selected.product.colour = {
				name: colour.name,
				hexadecimalCode: colour.hexadecimalCode,
			};

			vm.product.colour = colour.name;

			const thumbNailImg = document.querySelector(
				'.slider-nav-thumbnails img[data-media-id="' + colour.mediaId + '"]'
			);

			if (thumbNailImg) {
				changeSlideImgClick(thumbNailImg.parentElement.dataset.gslide);
			}

			vm.thicknesses = colourMatrixItem.thicknesses;

			if (document.querySelector('.colour.is-invalid')) {
				document.querySelector('.colour.is-invalid').classList.remove('is-invalid');
			}
			vm.$refs['selectColor'].classList.remove('is-invalid');
			vm.$refs['selectColor'].parentElement.classList.remove('is-invalid');

			this.resetInvalidDimension('thickness');
			this.resetInvalidDimension('diameter');
			this.resetInvalidDimension('tubeDiameter');
			this.isLimitedOrOutOfStock();

			vm.validate()

			vm.updateProductPrice();

			vm.closeColoursModal();
		},
		/**
		 * Resets the specified product dimension to 0 and sets the `showFromPrice` flag
		 * if the current value does not exist in the list of valid thicknesses.
		 *
		 * @param {string} dimension - The name of the dimension to validate (e.g., 'thickness', 'diameter').
		 */
		resetInvalidDimension: function (dimension) {
			const element = document.getElementById(dimension);
			if (element != null && element.tagName === 'SELECT') {
				const value = this.product.dimensions[dimension];
				const exists = this.thicknesses.some(item => item.value == value);
				if (!exists) {
					this.product.dimensions[dimension] = 0;
					this.showFromPrice = true;
				} else {
					this.showFromPrice = false;
				}
			}
		}

	},
};
